<script>
    import {getContext, onMount} from "svelte";
    import {FlatToast, ToastContainer, toasts} from "svelte-toasts";
    import PickCoordinateComponent from "./PickCoordinateComponent.svelte";
    import {navigate} from "svelte-routing";
    import Toggle from "svelte-toggle";

    const { open } = getContext('simple-modal');

    export let model_root;
    export let mid;
    export let cid;
    export let cname;

    let map_items = [];
    let map_config = {
        zoom: 4
    };

    onMount(() => {
        loadMapElems().then(mapItems => {
            map_items = mapItems;
        })
        loadMapConfig().then(mapConfig => {
            map_config = mapConfig[0];
        })
    })

    const setCoordsCallback = (index, coords) => {
        map_items[index].coordinates = coords;
    };

    function openCoordPicker(index, lat, lng) {
        open(PickCoordinateComponent, {
            index: index,
            lat: lat,
            lng: lng,
            setCoords: setCoordsCallback
        }, {
            closeButton: false,
            closeOnEsc: false,
            closeOnOuterClick: false,
            styleWindow: {
                overflow: 'hidden'
            },
            styleContent: {
                padding: '0 0',
                width: '100%',
                height: '580px'
            }
        }, {});
    }

    const loadMapConfig = () => {
        return fetch(model_root + 'shared/maps/get_map_config.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    const loadMapElems = () => {
        return fetch(model_root + 'shared/maps/get_map.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    const addMapElem = () => {
        map_items = [...map_items,
            {
                title: "",
                description: "",
                focus_elem: false,
                coordinates: "",
                lat: "51.345401",
                lng: "10.146764",
                key: (Math.random() + 1).toString(36).substring(7)
            }
        ];
    }

    const changeFocusOfElem = (index, value) => {
        if (value === true) {
            for(let item of map_items) {
                item.focus_elem = false;
            }
        }
        map_items[index].focus_elem = value;
    }

    const removeMapElem = (index) => {
        map_items.splice(index, 1);
        map_items = map_items;
    }

    function deleteEntireMapInDB() {
        return fetch(model_root + 'admin/maps/delete_map.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.text())
            .then(msg => {
                if (msg !== "success") {
                    toasts.error('Fehler bei Vorbereitungen zum Speichern der Karte', msg, { duration: 10000 });
                }
            });
    }

    async function createMapInDB() {
        if (map_items.length < 1) {
            toasts.error('Keine Punkte', "Der Karte muss mindestens ein Punkt hinzugefügt werden.", {duration: 10000});
            return;
        }
        await deleteEntireMapInDB();
        const data = new FormData();
        data.append("map_cid", cid);
        data.append("map_zoom", map_config.zoom);

        fetch(model_root + 'admin/maps/create_map.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(async msg => {
                if (msg === "success") {
                    for (let i in map_items) {
                        try {
                            await createMapElemInTB(i);
                        } catch (e) {
                            await deleteEntireMapInDB();
                            return;
                        }
                    }
                    toasts.success('Karte erfolgreich gespeichert', 'Das Fenster schließt sich automatisch.', {duration: 3000});
                    setTimeout(() =>{
                        navigate("/menu-item/"+mid, {replace: true})
                    }, 3000);
                } else {
                    toasts.error('Fehler beim Speichern der Karte', msg, {duration: 10000});
                    await deleteEntireMapInDB();
                }
            });
    }

    function createMapElemInTB(index) {
        const data = new FormData();
        data.append("me_cid", cid);
        data.append("me_title", map_items[index].title);
        data.append("me_description", map_items[index].description);
        data.append("me_focus_elem", map_items[index].focus_elem);
        data.append("me_coordinates", map_items[index].coordinates);

        return new Promise((resolve, reject) => {
            fetch(model_root + 'admin/maps/create_map_elem.php', {
                method: "POST",
                body: data
            })
                .then(response => response.text())
                .then(msg => {
                    if (msg === "success") {
                        resolve()
                    } else {
                        toasts.error('Falscher Wert für ein Kartenpunkt', msg, {duration: 10000});
                        reject();
                    }
                });
        });

    }

</script>

<ToastContainer placement="bottom-right"
                showProgress="true"
                let:data={data}>
    <FlatToast {data} />
</ToastContainer>

<h4 class="text-muted">MapDesigner</h4>
<h2 class="mb-4">{@html cname}</h2>

<form on:submit|preventDefault
      on:reset|preventDefault>

    <div class="row mb-3">
        <label class="col-sm-4 col-form-label">Map Zoom*:</label>
        <div class="col-sm">
            <input type="number" class="form-control" min="0" max="20"
                   bind:value={map_config.zoom}>
        </div>
    </div>

    <hr class="mb-3">

    <div>
        {#each map_items as item, index}
            <div class="row mb-3 px-2 form-list-item">
                <div class="border rounded p-3">
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Point title*:</label>
                        <div class="col-sm">
                            <input type="text" class="form-control" bind:value={item.title}>
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Point description:</label>
                        <div class="col-sm">
                            <input type="text" class="form-control" placeholder="optional" bind:value={item.description}>
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Point coordinate*:</label>
                        <div class="col-sm">
                            <input on:focus={ () => { openCoordPicker(index, item.lat, item.lng) }} type="text" class="form-control" placeholder="Click to pick a coordinate" bind:value={item.coordinates}>
                        </div>
                    </div>
                    <div class="row my-1">
                        <label class="col-sm-4 col-form-label">Set as focus-point?</label>
                        <div class="col-sm pt-2">
                            <Toggle toggled={item.focus_elem} hideLabel={true} toggledColor="#2d3e4f" on:toggle={(e) => {changeFocusOfElem(index, e.detail)}} />
                        </div>
                    </div>
                    <hr class="my-3">
                    <div class="row my-1">
                        <div class="col">
                            <button class="btn btn-outline-secondary w-auto py-1 px-2" on:click={() => { removeMapElem(index) }}>
                                <small>
                                    <i class="far fa-trash-alt"></i> Remove point
                                </small>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        {/each}
    </div>

    <button class="btn btn-link text-dark" on:click={addMapElem}>Add point</button>

    <hr class="mb-4">

    <button class="btn btn-primary me-2" on:click={createMapInDB}>Save map</button>
    <button class="btn btn-secondary" on:click={() => {navigate("/menu-item/"+mid, {replace: true})}}>Dismiss changes</button>
</form>
